import { getPreviousUserCache } from '@agyletime/vue-3-common/src/composables/loggedInUserStore';
import { User } from '@agyletime/vue-3-common/src/typings/user';
import { fetchFromLambda } from '@agyletime/vue-3-common/src/utils/apiService';

export const getUserData = async (fields: Array<keyof User>) => {
    let cachedUser: User = getPreviousUserCache();
    
    if (!cachedUser.email?.length) {
        cachedUser = await fetchFromLambda(
            '/organisation/users/me'
        );
    }

    return fields.reduce((acc, field) => {
        if (cachedUser[field] !== undefined) {
            (acc as Record<string, unknown>)[field] = cachedUser[field];
        }
        return acc;
    }, {} as Partial<User>);
};